import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CiacService } from 'src/app/services/http/ciac.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-form-conversoes',
  templateUrl: './form-conversoes.component.html',
  styleUrls: ['./form-conversoes.component.scss']
})
export class FormConversoesComponent implements OnInit {

  sorting: { 
    id: "asc",
    nome: "",
  }

  filter = {
    sorting: { 
      id: "asc",
      nome: ""
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };

  form = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    fornecedor: new FormControl('', [Validators.required]),
    valorInicial: new FormControl(''),
    valorFinal: new FormControl('')
  });

  listaConversoes = [];
  listaFornecedores = [];
  id;
  idDados = 1;

  constructor(private ciacService: CiacService, private modal: ModalMsgService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.initialize();

    this.id = this.activatedRoute.snapshot.params.id || null;
    if(this.id) {
      this.ciacService.getConversao(this.id).then(c => {
        this.form.patchValue(c);
        this.form.controls.fornecedor.patchValue(c['idFornecedor']);
        c['valores'].forEach(e => {
          this.listaConversoes.push({
            'id': e.id,
            'valorInicial': e.valorDe,
            'valorFinal': e.valorPara,
          });
        });
      });
    }
  }

  initialize() {
    this.ciacService.getListaFornecedores(this.filter).then(f => {
      this.listaFornecedores = this.listaFornecedores.concat(f.lista);
    });
  }

  addParamConversao() {
    if(this.form.controls.valorInicial.value != '' && this.form.controls.valorFinal.value != '') {
      let dados = {
        id: String(this.idDados++),
        valorInicial: this.form.controls.valorInicial.value,
        valorFinal: this.form.controls.valorFinal.value
      }
      this.listaConversoes.push(dados);
      this.form.controls.valorInicial.reset();
      this.form.controls.valorFinal.reset();
    }
  }

  editParamConversao(id) {
    this.listaConversoes.filter(c => {
      if(c.id === id) {
        this.form.controls.valorInicial.patchValue(c.valorInicial);
        this.form.controls.valorFinal.patchValue(c.valorFinal);
        let index = this.listaConversoes.indexOf(c);
        if ( index > -1) {
          this.listaConversoes.splice(index, 1);
        }
      }
    });
  }

  delParamConversao(id) {
    this.listaConversoes.filter(c => {
      if(c.id === id) {
        let index = this.listaConversoes.indexOf(c);
        if ( index > -1) {
          this.listaConversoes.splice(index, 1);
        }
      }
    });
  }

  criarJson() {
    let dados;
    let conversao = [];

    if(this.id != '' && this.id != null) {
      this.listaConversoes.forEach(c => {
        let array = {
          valorDe: c.valorInicial,
          valorPara: c.valorFinal
        }
        conversao.push(array);
      });

      dados = {
        id: parseInt(this.id),
        nome: this.form.controls.nome.value,
        idFornecedor: parseInt(this.form.controls.fornecedor.value),
        valores: conversao,
      }

    }else {

      this.listaConversoes.forEach(c => {
        let array = {
          valorDe: c.valorInicial,
          valorPara: c.valorFinal
        }
        conversao.push(array);
      });
  
      dados = {
        nome: this.form.controls.nome.value,
        idFornecedor: parseInt(this.form.controls.fornecedor.value),
        valores: conversao,
      }

    }
    return dados;
  }

  submitForm() {
    let params = this.criarJson();
    if(this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }else {
      if(this.id && this.id !=null) {

        this.ciacService.editConversao(params).then(c => {
          if(c.success) {
            this.router.navigate(['ciac', 'conversao', 'listar']);
          }else {
            this.modal.openDialog(
              'Erro ao editar conversão',
              'Por favor, verifique os campos.',
              'danger'
            );
            return;
          }
        });

      }else {

        this.ciacService.addConversao(params).then(c => {
          if(c.success) {
            this.router.navigate(['ciac', 'conversao', 'listar']);
          }else {
            this.modal.openDialog(
              'Erro ao cadastrar conversão',
              'Por favor, verifique os campos.',
              'danger'
            );
            return;
          }
        });

      }
    }
  }

}
